export default __webpack_public_path__ + "static/media/Love_Flag.b00e615d.png";